"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _loginLog = require("@/api/loginLog");
var _userAgent = require("@/utils/userAgent");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'LoginLog',
  data: function data() {
    return {
      loading: false,
      dataList: [],
      total: 0,
      page: 1,
      limit: 20,
      timeVal: [],
      queryForm: {
        account: '',
        ip: '',
        status: '',
        dateLimit: ''
      }
    };
  },
  mounted: function mounted() {
    this.getDataList();
  },
  methods: {
    summarizeUserAgent: _userAgent.summarizeUserAgent,
    displayHeaderValue: _userAgent.displayHeaderValue,
    getDataList: function getDataList() {
      var _this = this;
      this.loading = true;
      (0, _loginLog.loginLogListApi)({
        page: this.page,
        limit: this.limit,
        account: this.queryForm.account,
        ip: this.queryForm.ip,
        status: this.queryForm.status,
        dateLimit: this.queryForm.dateLimit
      }).then(function (res) {
        _this.dataList = res.list || [];
        _this.total = res.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleDateChange: function handleDateChange(val) {
      this.queryForm.dateLimit = val && val.length === 2 ? val.join(',') : '';
    },
    resetQuery: function resetQuery() {
      this.timeVal = [];
      this.queryForm = {
        account: '',
        ip: '',
        status: '',
        dateLimit: ''
      };
      this.page = 1;
      this.getDataList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.limit = val;
      this.page = 1;
      this.getDataList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getDataList();
    }
  }
};